import { useSyncExternalStore } from 'react';

/** Carbon grid breakpoints (px) – keep in sync with @carbon/layout. */
export const breakpoints = {
  sm: 320,
  md: 672,
  lg: 1056,
  xlg: 1312,
  max: 1584,
} as const;

export type Breakpoint = keyof typeof breakpoints;

const query = (bp: Breakpoint) => `(min-width: ${breakpoints[bp] / 16}rem)`;

/**
 * Mobile-first media query hook: `useBreakpoint('lg')` is true at ≥ 1056px.
 * Prefer CSS for layout; use this only when markup must change (e.g. table ↔ cards).
 */
export const useBreakpoint = (bp: Breakpoint): boolean => {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query(bp));
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query(bp)).matches,
    () => false,
  );
};
